import MuiIconButton, { IconButtonProps } from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";

interface CustomIconButtonProps extends IconButtonProps {
  variant?: "rounded" | "circle";
  // Add any additional props if needed
}

const IconButton = styled(MuiIconButton)<CustomIconButtonProps>(
  ({ theme, variant = "circle" }) => ({
    borderRadius: variant === "rounded" ? "8px" : "50%"
  })
);

export default IconButton;
